import { render, staticRenderFns } from "./ReportIcon.vue?vue&type=template&id=2f357bba&"
import script from "./ReportIcon.vue?vue&type=script&lang=ts&"
export * from "./ReportIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports